/**
 * Rarea List Loader - Automatic Shiku Dispatcher
 */
const initRareaList = () => {
    const container = document.getElementById('jichica-rarea-list');
    if (!container) return;

    if (typeof myJichicaConfig === 'undefined' || !myJichicaConfig.sharedUrl) {
        // console.error('Debug: myJichicaConfig or sharedUrl is missing.');
        return;
    }

    // 表示する共通メッセージの定義（デザインはお知らせ一覧の空文字に統一）
    const noDataMessage = '<div class="no-news-message fs-s c-text-gray mgt-s">現在、準備中です。</div>';

    // ★重要：ここで shiku（スラッグ）を使ってファイル名を動的に生成する
    // 設定がなければデフォルトでsakaekuにする
    // const shiku = myJichicaConfig.shikuSlug || 'sakaeku';
    // ★修正点：デフォルトをセット
    let shiku = myJichicaConfig.shikuSlug || 'sakaeku';
    // console.log('shiku ' + shiku);

    // ★追加：メインサイト（isJichikaiSite が false）の場合は、強制的に 'main' を読むように上書き
    if (myJichicaConfig.isMainSite === true || myJichicaConfig.isMainSite === '1') {
        shiku = 'main';
    }
    const jsonUrl = `${myJichicaConfig.sharedUrl.replace(/\/$/, '')}/${shiku}_rarea_list.json?t=${new Date().getTime()}`;

    // ==========================================
    // ★追加：デバッグ用コンソール出力（確認用）
    // ==========================================
    // console.log('【ヤムG通信】isJichikaiSiteの判定:', myJichicaConfig.isJichikaiSite);
    // console.log('【ヤムG通信】現在の区判定(shiku):', shiku);
    // console.log('【ヤムG通信】読み込んでいるJSON URL:', jsonUrl);

    fetch(jsonUrl)
        .then(res => {
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.json();
        })

        .then(data => {
            // if (!data || data.length === 0) return;
            // ★修正点1：JSONデータがない、または空配列の場合にメッセージを表示
            if (!data || data.length === 0) {
                container.innerHTML = noDataMessage;
                return;
            }

            // 1. メインとサブのプールを分離
            const mainItems = data.filter(item => item.pool_type === 'main');
            const subItems = data.filter(item => item.pool_type === 'sub');

            // 2. メインプールからランダムに3件抽出
            // ※配列をランダムに並び替えて、先頭から3つを取得
            const selectedMain = mainItems
                .sort(() => Math.random() - 0.5)
                .slice(0, 3);

            // 3. 抽出したメイン3件と、サブプール（通常2件）を結合
            const displayItems = [...selectedMain, ...subItems];

            // ★修正点2：プールを結合した結果、最終的な表示アイテムが0件の場合もケア
            if (displayItems.length === 0) {
                container.innerHTML = noDataMessage;
                return;
            }

            let html_items = '';
            displayItems.forEach((item, index) => {
                const link = item.external_link || '#';
                const title = item.external_title || '無題';
                const img = item.featured_image_url || '';
                const date = item.external_date || '';

                html_items += `
                    <li class="archive-list-item trans radius-s glow" data-index="${index}">
                        <a class="archive-list-item-link p-relative" href="${link}" target="_blank" rel="noopener">
                            <div class="archive-image-wrap">
                                <img src="${img}" alt="${title}" class="object-fit-cover radius-s" loading="lazy" style="aspect-ratio: 16/9;">
                            </div>
                            <div class="archive-list-item-text p-relative">
                                <h3 class="fs-m no-margin text-ellipsis lh-1-3">${title}</h3>
                                <div class="mgt-05 item-meta flex flex-wrap flex-jc-sb">
                                    <span class="fs-s bold c-text-gray">PR</span>
                                    <span class="item-date fs-s c-text-gray">${date}</span>
                                </div>
                            </div>
                        </a>
                    </li>`;
            });

            container.innerHTML = `
                <div class="rarea-container">
                    <ul class="archive-list grid gap-xs grid-sp1-pc2 mgt-m list-style-none no-padding">
                        ${html_items}
                    </ul>
                </div>`;
        })
        .catch(err => {
            // console.error('Debug: Fetch Error:', err);
            // console.error('Debug: Fetch Error:', err);

            // 他のスクリプトの初期化クリア処理が終わるのを待ってから時間差で書き込む
            setTimeout(() => {
                const activeContainer = document.getElementById('jichica-rarea-list');
                if (activeContainer) {
                    activeContainer.innerHTML = noDataMessage;
                }
            }, 1000);
        });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRareaList);
} else {
    initRareaList();
}